import React__default, { forwardRef, useCallback } from 'react';
import { UnstyledTextInput } from './UnstyledTextInput.js';
import TextInputWrapper from './TextInputWrapper.js';
import TextInputInnerVisualSlot from './TextInputInnerVisualSlot.js';
import TextInputInnerAction from './TextInputInnerAction.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import Box from '../Box/Box.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TextInput = /*#__PURE__*/forwardRef(({
  placeholder,
  sx: sxProp,
  isDisabled,
  block,
  loading,
  loaderPosition = 'auto',
  leadingVisual: LeadingVisual,
  trailingVisual: TrailingVisual,
  onFocus,
  onBlur,
  trailingAction,
  size: sizeProp,
  testId,
  type = 'text',
  'aria-label': ariaLabel,
  ...props
}, forwardedRef) => {
  const [isInputFocused, setIsInputFocused] = React__default.useState(false);
  const innerRef = React__default.useRef(null);

  // const {label, description, errorMessage} = props
  // const {labelProps, inputProps, descriptionProps, errorMessageProps} = useTextField(props, innerRef)

  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const showLeadingLoadingIndicator = loading && (loaderPosition === 'leading' || Boolean(LeadingVisual && loaderPosition !== 'trailing'));
  const showTrailingLoadingIndicator = loading && (loaderPosition === 'trailing' || Boolean(loaderPosition === 'auto' && !LeadingVisual));
  const focusInput = () => {
    var _innerRef$current;
    (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.focus();
  };
  const handleInputFocus = useCallback(e => {
    setIsInputFocused(true);
    if (onFocus) onFocus(e);
  }, [onFocus]);
  const handleInputBlur = useCallback(e => {
    setIsInputFocused(false);
    if (onBlur) onBlur(e);
  }, [onBlur]);
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(TextInputWrapper, {
    hasLeadingVisual: Boolean(LeadingVisual || showLeadingLoadingIndicator),
    hasTrailingVisual: Boolean(TrailingVisual || showTrailingLoadingIndicator),
    hasTrailingAction: Boolean(trailingAction),
    isDisabled: isDisabled,
    onClick: focusInput,
    size: sizeProp,
    "aria-live": "polite",
    "aria-busy": Boolean(loading),
    sx: sxProp,
    testId: testId ? `${testId}-text-input-wrapper` : undefined
  }, /*#__PURE__*/React__default.createElement(TextInputInnerVisualSlot, {
    visualPosition: "leading",
    showLoadingIndicator: showLeadingLoadingIndicator,
    hasLoadingIndicator: typeof loading === 'boolean'
  }, typeof LeadingVisual === 'function' ? /*#__PURE__*/React__default.createElement(LeadingVisual, null) : LeadingVisual), /*#__PURE__*/React__default.createElement(UnstyledTextInput, _extends({
    placeholder: placeholder,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    disabled: isDisabled,
    "data-component": "input",
    "aria-label": ariaLabel,
    "data-testid": testId ? `${testId}-unstyled-text-input` : undefined,
    ref: innerRef
  }, props)), /*#__PURE__*/React__default.createElement(TextInputInnerVisualSlot, {
    visualPosition: "trailing",
    showLoadingIndicator: showTrailingLoadingIndicator,
    hasLoadingIndicator: typeof loading === 'boolean'
  }, typeof TrailingVisual === 'function' ? /*#__PURE__*/React__default.createElement(TrailingVisual, null) : TrailingVisual), trailingAction));
});
TextInput.displayName = 'TextInput';
var TextInput$1 = Object.assign(TextInput, {
  Action: TextInputInnerAction
});

export { TextInput$1 as default };
